<div class="container font-Roboto">
  <footer [ngClass]="(isMobile$ | async) ? '' : 'footer-container mx-auto'">
    <div class="row d-none d-md-block footer-subscribe-spacer">
      <div class="col-md-12 rounded-pill scalped-border bg-secondary border">
        <div class="row footer-container-padding">
          <div class="col-lg-4 col-md-12 text-md-left">
            <b>Get LM content in your inbox.</b> <br />
            <span>Subscribe to our mailing list</span>
          </div>
          <div class="col-lg-8 col-md-12">
            <form #subscriptionForm="ngForm" (ngSubmit)="subscribeToMailing(subscriptionForm)" class="row g-0">
              <div class="col">
                <input
                  required
                  ngModel
                  name="first_name"
                  type="text"
                  class="form-control rounded-end-0 scalped-border-adjusted py-3"
                  placeholder="First name"
                  aria-label="First name"
                  />
                </div>
              <div class="col">
                  <input
                    required
                    ngModel
                    name="last_name"
                    type="text"
                    class="form-control rounded-0 py-3"
                    placeholder="Last name"
                    aria-label="Last name"
                    />
                  </div>
              <div class="col">
                    <input
                      required
                      ngModel
                      name="email"
                      type="text"
                      class="form-control rounded-0 py-3"
                      placeholder="Email"
                      #email="ngModel"
                      [pattern]="emailPattern"
                      title="Please enter a valid email"
                      />

                    </div>
              <div class="col">
                <app-button-solid [buttonDetails]="subscriptionButton1" [disabled]="subscriptionForm.invalid"></app-button-solid>
              </div>
            </form>
            @if (email.errors && formSubmit) {
              <div class="pt-2" style="color: red">Please enter your first name, last name and a valid email address.</div>
            }
            @if (errorText) {
              <div style="color: red">{{ errorText }}</div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="row d-block d-sm-none footer-subscribe-spacer">
      <div class="col-md-12">
              <div class="card p-4 rounded bg-secondary">
                <div class="card-header text-center bg-transparent border-0 my-md-3">
                  <b>Get LM content in your inbox.</b> <br />
                  <span>Subscribe to our mailing list</span>
                </div>
                <div class="card-body">
                  <app-form
                    [buttonDetails]="subscriptionButton2"
                    [formFields]="subscriptionFields"
                    (form)="subscribeToMailing($event)"
                  ></app-form>
                </div>
              </div>
            </div></div>
      <div class="row">
            @for (item of footerMenuItems; track item) {
              <div class="col">
                <h5 [routerLink]="item?.href">{{ item.menu }}</h5>
                <ul class="list-unstyled text-small">
                  @for (menuItem of item.submenus; track menuItem) {
                    <li class="mb-1">
                      <a class="footer-link-color text-decoration-none" [routerLink]="menuItem?.link" [fragment]="menuItem?.fragment">{{
                        menuItem.name
                      }}</a>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
      <div class="row">
        <div class="col-md-3 col-sm-12 offset-md-9 border-top footer-social-container">
          <app-social-media-link></app-social-media-link>
        </div>
      </div>
  </footer>
  <div class="row">
    <div class="col-12 my-4 text-muted text-sm-center">
      <app-footer-chidalu></app-footer-chidalu>
    </div>
  </div>
</div>
